import { Directive, HostListener, ElementRef, Renderer2, Input } from '@angular/core';
import { KeyBoardService } from '../../core-services/keyboard.service';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[arrow-nav]',
    standalone: false
})
export class CfetNavigationDirective {
  @Input('arrow-nav') checkMenu: string;
  constructor(private keyboardService: KeyBoardService, public element: ElementRef, private render: Renderer2) {
    this.render.setAttribute(this.element.nativeElement, 'tabindex', '0');
  }

  @HostListener('keydown', ['$event']) onKeyUp(e) {
    switch (e.keyCode) {
      case 38:
        e.preventDefault();
        this.keyboardService.sendMessage({ element: this.element, action: 'UP' });
        break;
      case 37:
        e.preventDefault();
        this.keyboardService.sendMessage({ element: this.element, action: 'LEFT' });
        break;
      case 40:
        e.preventDefault();
        this.keyboardService.sendMessage({ element: this.element, action: 'DOWN' });
        break;
      case 39:
        e.preventDefault();
        this.keyboardService.sendMessage({ element: this.element, action: 'RIGHT' });
        break;
      case 32:
        e.preventDefault();
        this.keyboardService.sendMessage({ element: this.element, action: 'SPACE' });
        break;
      case 27:
        e.preventDefault();
        this.keyboardService.sendMessage({ element: this.element, action: 'ESC' });
        break;
      case 9:
        e.preventDefault();
        if (e.shiftKey) {
          this.keyboardService.sendMessage({ element: this.element, action: 'SHIFT+TAB' });
        } else {
          this.keyboardService.sendMessage({ element: this.element, action: 'TAB' });
        }
        break;
    }
  }

}
